import { CustomerInfo, getSchema } from "./customer_info";

const CustomerInfoForm = {
  Form: CustomerInfo,
  getSchema,
};

export default CustomerInfoForm;
